// Broker quantity vs economic units. MCX options: the broker trades 1 (lot) while each 1.00 of
// premium is worth units_per_quantity (CRUDEOIL 100); the stored strategy `quantity` is their
// product. NFO: units 1, so the broker quantity is the whole story.
//
// ONE way to write a quantity (UI/UX audit Phase 3): "2 lots × 30 = 60" everywhere a lot size is known -
// MCX and NFO alike, so "−1" (MCX lots) and "−2475" (NFO shares) never sit in one column again.

/** "−3 lots × 825 = −2,475" (a position, signed) or, with { signed: false }, "3 lots × 825 = 2,475" (a size or
 *  a fill). `qty` and `lotSize` in the same (economic) units; without a usable lot size, the quantity alone. */
export function formatLots(qty, lotSize, { signed = true } = {}) {
  if (qty == null || Number.isNaN(Number(qty))) return "—";
  const q = Number(qty);
  const lot = Number(lotSize);
  const n = (v) => Math.abs(v).toLocaleString("en-IN", { maximumFractionDigits: 4 });
  const sign = !signed ? "" : q < 0 ? "−" : q > 0 ? "+" : "";
  if (!lot || lot <= 0) return `${sign}${n(q)}`;
  const lots = Math.abs(q) / lot;
  if (Math.abs(lots - Math.round(lots)) > 1e-6) return `${sign}${n(q)}`;
  const l = Math.round(lots);
  return `${sign}${l} lot${l === 1 ? "" : "s"} × ${n(lot)} = ${sign}${n(q)}`;
}

/** A fill / order row: "2 lots × 30 = 60" when the row knows its lots, else "1 · Units 100" (MCX) or "650" (NFO). */
export function qtyLabel(r) {
  if (!r) return "—";
  const units = Number(r.units_per_quantity) || 1;
  const broker = r.broker_quantity ?? r.quantity;
  if (broker == null) return "—";
  const econ = Number(broker) * units;
  const lots = Number(r.lots);
  if (lots > 0 && econ > 0) return formatLots(econ, econ / lots, { signed: false });
  return units !== 1 ? `${broker} · Units ${units}` : `${broker}`;
}
